import { createContext, useState } from "react";

export const ProgressBarContext = createContext({
  progressBarValue: null,
  setProgressBarValue: () => null,
});

export const ProgressBarProvider = ({ children }) => {
  const [progressBarValue, setProgressBarValue] = useState(null);
  const value = { progressBarValue, setProgressBarValue };
  return (
    <ProgressBarContext.Provider value={value}>
      {children}
    </ProgressBarContext.Provider>
  );
};
